export enum FontFamily {
  CocogoosePro = 'Cocogoose Pro',
  ProximaNova = 'Proxima Nova',
  ProximaNovaMedium = 'Proxima Nova Medium',
  ProximaNovaSemibold = 'Proxima Nova Semibold',
}

export const FontUrl: Record<FontFamily, string> = {
  [FontFamily.CocogoosePro]: '/fonts/Cocogoose-Pro/Cocogoose-Pro-Light.otf',
  [FontFamily.ProximaNova]: '/fonts/Proxima-Nova/Proxima-Nova-Regular.otf',
  [FontFamily.ProximaNovaMedium]: '/fonts/Proxima-Nova/Proxima-Nova-Medium.otf',
  [FontFamily.ProximaNovaSemibold]:
    '/fonts/Proxima-Nova/Proxima-Nova-Semibold.otf',
}
